import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../features/auth/authSlice";
import { templateReducer } from "../features/superAdmin/ticketService/template/template.slice";
import { authServiceApi } from "./authServiceApi";
import { invalidateAllTagsOnSignInMiddleware } from "./middleware/middleware";
import { employeeManagementServiceApi } from "./superAdmin/employeeManagementServiceApi";
import { ticketServiceApi } from "./superAdmin/ticketServiceApi";

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [ticketServiceApi.reducerPath]: ticketServiceApi.reducer,
    [employeeManagementServiceApi.reducerPath]:
      employeeManagementServiceApi.reducer,

    auth: authReducer,
    template: templateReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authServiceApi.middleware)
      .concat(ticketServiceApi.middleware)
      .concat(employeeManagementServiceApi.middleware)
      .concat(invalidateAllTagsOnSignInMiddleware([authServiceApi])),
});

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
